import { DropitState } from "."
import { ActionTypes } from "../actions/act_types"
import { IReferenceIsgUrl } from "../requests"

export default (
  state: IReferenceIsgUrl[] = [],
  action: any
): IReferenceIsgUrl[] => {
  switch (action.type) {
    case ActionTypes.FETCH_ISG_URLS:
      return action.urls
    default:
      return state
  }
}

export const getIsgUrl = (state: DropitState, idSocieteg: string) =>
  state.referenceIsgUrls.find((u) => u.idSocieteg + "" === idSocieteg + "")
    ?.url || ""
